import { createObjectField, createPrimitiveField, type InferFieldValue, nullable } from '@adv-frontend/form-kit';
import { type OpenApiSchemaMediaItemMetadata } from '../../../api/schema';

export const createMediaMetadataField = () =>
    createObjectField({
        fields: {
            thumbHash: createPrimitiveField({ defaultValue: '' }),
            backgroundColors: createObjectField({
                fields: {
                    bottom: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                    left: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                    right: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                    top: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                },
            }),
        },
    });

export type MediaMetadataFieldValue = InferFieldValue<ReturnType<typeof createMediaMetadataField>>;

export const makeEmptyMediaMetadata = (): MediaMetadataFieldValue => {
    return {
        thumbHash: '',
        backgroundColors: {
            bottom: null,
            left: null,
            right: null,
            top: null,
        },
    };
};

export const mapFileMetadataToMediaMetadata = (metadata?: OpenApiSchemaMediaItemMetadata): MediaMetadataFieldValue =>
    metadata
        ? {
              thumbHash: metadata.thumb_hash,
              backgroundColors: metadata.background_colors,
          }
        : makeEmptyMediaMetadata();

export const mapMediaMetadataToFileMetadata = (
    metadata: MediaMetadataFieldValue
): OpenApiSchemaMediaItemMetadata | undefined =>
    metadata.thumbHash
        ? {
              thumb_hash: metadata.thumbHash,
              background_colors: metadata.backgroundColors,
          }
        : undefined;
